
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule-an-appointment",
      function () {
        return require("private-next-pages/schedule-an-appointment/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule-an-appointment"])
      });
    }
  